// extracted by mini-css-extract-plugin
export default {"form":"AnswerForm_form__lngsH","control":"AnswerForm_control__Trcbg"};